import React from 'react';
import {getLocalData} from "utils/util";
import './detail.less';
import axios from '../../../utils/new_request';
import { SchoolMajorTable } from 'shijie_npm2';
import 'shijie_npm2/dist/main.css';

export default class WishListAnalyzeDetailIndex extends React.Component{
    user_detail=getLocalData('user_detail');
    constructor() {
        super();
        this.state={
        }
    }

    componentDidMount() {
        // 进入详细页，埋点
        window.gtag('event', '访问详情结果页', {
            'send_to': 'UA-127148765',
        });
    }
    
    async getAnalysisDetail(currentPage) {
        let {analysisData, provinceId, year, selectedScoreType, selectedCombinationList,}=this.props.location.state;
        let item={};
        item.provinceId = provinceId;
        item.year = year;
        if(selectedScoreType!=0){
            item.intentionScoreline = {branch:selectedScoreType};
        }else {
            // item.intentionScoreline = {};
        }
        item.intentionSubjects = selectedCombinationList;
        item.universityIds=[];
        item.xkEntryIds=[];
        analysisData.entryGroups.slice(10*(currentPage-1),10*currentPage).forEach(i=>{
            item.universityIds.push(i.universityId);
            i.entryList.forEach(j=>{
                item.xkEntryIds.push(j.id)
            })
        })
        return await axios.post(`/xbag/college/purpose/xk_coach/analysis/detail?user_id=${this.user_detail.id}&page=${currentPage}`, item);
    }
    render() {
        let {analysisData, selectedCombinationNameList,}=this.props.location.state;

        return <SchoolMajorTable 
            analysisData={analysisData}
            selectedCombinationNameList={selectedCombinationNameList}
            // requirementDetailList={requirementDetailList}
            scene="mobile"
            getAnalysisDetail={this.getAnalysisDetail.bind(this)}
            noHeader
        ></SchoolMajorTable>
    }
}



// WEBPACK FOOTER //
// ./src/pages/xkCoach/wishListAnalyze/detail.js